import * as preact from "preact";

import AppRootView, { type MainLayoutProps } from "AppRootView";
import * as pageTransitions from "pageTransitions";
import type PreactPage from "pages/PreactPage";

let rootContainer: HTMLElement | undefined;
let rootView: AppRootView | undefined;

const toElement = (containerElement: HTMLElement | JQuery<HTMLElement>) =>
  containerElement instanceof HTMLElement
    ? containerElement
    : containerElement[0];

const mountRoot = (containerElement: HTMLElement) => {
  rootContainer = containerElement;
  while (containerElement.firstChild) {
    containerElement.removeChild(containerElement.firstChild);
  }
  preact.render(
    <AppRootView
      ref={(view) => {
        rootView = view ?? undefined;
      }}
    />,
    containerElement
  );
};

export const renderPage = async (
  containerElement: HTMLElement | JQuery<HTMLElement>,
  page: PreactPage,
  renderedCallback: (renderedOptions?: any) => void,
  appRouter: any,
  options?: any,
  mainLayoutProps?: MainLayoutProps,
  /** To do as the page changes, rather than before */
  beforeRender?: () => void
) => {
  const nextRootContainer = toElement(containerElement);
  if (rootContainer !== nextRootContainer) {
    close();
    mountRoot(nextRootContainer);
  }

  let markRendered!: () => void;
  const rendered = new Promise<void>((resolve) => {
    markRendered = resolve;
  });
  await pageTransitions.show(
    page.name,
    async () => {
      rootView?.leavePage();
      beforeRender?.();
      await rootView?.renderPage({
        appRouter,
        mainLayoutProps,
        options,
        page,
        renderedCallback: (renderedOptions) => {
          markRendered();
          renderedCallback(renderedOptions);
        },
      });
    },
    rendered
  );
};

export const updateMainLayoutProps = async (
  mainLayoutProps: MainLayoutProps
) => {
  await rootView?.updateMainLayoutProps(mainLayoutProps);
};

const close = () => {
  if (rootContainer) {
    preact.render(null, rootContainer);
  }

  rootContainer = undefined;
  rootView = undefined;
};
